/* AW Library | aw-base.js | v0.4.0
   אנימציית כניסה לאלמנטים עם data-aw-reveal, וכותרות שנכנסות מילה אחרי מילה. ונילה, בלי תלויות.
   נטען פעם אחת ע"י aw-tokens. בטוח לטעינה כפולה. */
(function () {
  if (window.__awBase) return;
  window.__awBase = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var observer = null;

  function show(el) {
    el.classList.add('aw-in');
  }

  if (!reduce && !designMode && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var target = entry.target;
          if (target.__awClipKids) target.__awClipKids.forEach(show);
          if (!target.__awClipKids || target.hasAttribute('data-aw-reveal')) show(target);
          observer.unobserve(target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
  }

  /* כותרת מילה אחרי מילה: עוטף כל מילה ב-span. רק כש-aw-tokens הוסיף aw-split ל-html,
     ורק לכותרת שיושבת בתוך אלמנט עם data-aw-reveal (הוא זה שמפעיל את הכניסה).
     עובר על צמתי טקסט בלבד, כך ש-span של צבע האקסנט נשאר במקומו. */
  var splitOn = document.documentElement.classList.contains('aw-split') && !reduce && !designMode;

  function split(heading) {
    if (heading.__awSplit) return;
    heading.__awSplit = true;
    var index = 0;
    var walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (!node.nodeValue.trim()) return;
      var frag = document.createDocumentFragment();
      node.nodeValue.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          frag.appendChild(document.createTextNode(' '));
          return;
        }
        var word = document.createElement('span');
        word.className = 'aw-w';
        word.style.setProperty('--aw-wi', index++);
        word.textContent = part;
        frag.appendChild(word);
      });
      node.parentNode.replaceChild(frag, node);
    });
  }

  function init(scope) {
    if (splitOn) {
      var heads = (scope || document).querySelectorAll('[data-aw-reveal]:not(.aw-in) .aw-heading');
      for (var h = 0; h < heads.length; h++) split(heads[h]);
    }
    var els = (scope || document).querySelectorAll('[data-aw-reveal]:not(.aw-in)');
    for (var i = 0; i < els.length; i++) {
      if (!observer) {
        show(els[i]);
        continue;
      }
      /* חשיפת clip: Chrome מחשב את החיתוך של האלמנט עצמו, ואלמנט שחתוך לגמרי "לא במסך" לעולם.
         לכן עוקבים אחרי ההורה שלו (התגלה באתר הבדיקה, 2026-10-03: התמונות נשארו מוסתרות) */
      if (els[i].getAttribute('data-aw-anim') === 'clip' && els[i].parentElement) {
        var parent = els[i].parentElement;
        if (!parent.__awClipKids) parent.__awClipKids = [];
        if (parent.__awClipKids.indexOf(els[i]) === -1) parent.__awClipKids.push(els[i]);
        observer.observe(parent);
        continue;
      }
      observer.observe(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* --- קישורי עוגן בתוך סקשנים של הספרייה ---
     קישור כמו /#why או /products/x#reviews: אם היעד נמצא בעמוד הנוכחי, גוללים אליו בלי לטעון עמוד מחדש.
     scrollIntoView עובד גם כשהגלילה היא של מעטפת פנימית, ומכבד את scroll-margin של הסקשן. */
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href*="#"]') : null;
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) return;
    if (!link.closest('.aw-section, .aw-block')) return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (error) { return; }
    if (!url.hash || url.hash.length < 2) return;
    var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    var samePage = url.pathname === window.location.pathname;
    /* קישור לדף הבית עם עוגן (/#why): אם העוגן קיים גם כאן, נשארים בעמוד */
    if (!samePage && url.pathname !== '/') return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (samePage && window.history && window.history.replaceState) window.history.replaceState(null, '', url.hash);
    document.dispatchEvent(new CustomEvent('aw:anchor', { detail: { target: target } }));
  });

  /* --- וילון: סקשן נעוץ שגבוה מהמסך נדבק מהתחתית שלו --- */
  function pins() {
    var shells = document.querySelectorAll('.aw-edge-b-pin');
    for (var i = 0; i < shells.length; i++) {
      var shell = shells[i].parentElement;
      if (!shell) continue;
      shell.style.setProperty('--aw-pin-top', Math.min(0, window.innerHeight - shell.offsetHeight) + 'px');
    }
  }

  /* --- תמונה שזזה בגלילה: --aw-p בין -1 (מתחת למסך) ל-1 (מעל המסך) --- */
  var parallaxEls = [];
  var ticking = false;
  function parallax() {
    ticking = false;
    var vh = window.innerHeight;
    for (var i = 0; i < parallaxEls.length; i++) {
      var rect = parallaxEls[i].getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) continue;
      var p = (vh / 2 - (rect.top + rect.height / 2)) / (vh / 2 + rect.height / 2);
      parallaxEls[i].style.setProperty('--aw-p', Math.max(-1, Math.min(1, p)).toFixed(3));
    }
  }
  function collect() {
    parallaxEls = reduce ? [] : Array.prototype.slice.call(document.querySelectorAll('[data-aw-parallax]'));
    pins();
    parallax();
  }
  /* capture: תופס גם גלילה של מעטפת פנימית (Horizon בדסקטופ) */
  document.addEventListener('scroll', function () {
    if (!parallaxEls.length || ticking) return;
    ticking = true;
    window.requestAnimationFrame(parallax);
  }, { passive: true, capture: true });
  window.addEventListener('resize', collect);
  if (document.readyState === 'complete') collect();
  else window.addEventListener('load', collect);

  /* עורך התמות: סקשן שנוסף או נטען מחדש */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    collect();
  });
})();

/* קישורים פנימיים בשפה הנוכחית. קישור שנכתב בהגדרות סקשן ("/policies/shipping-policy", "/#signup")
   לא מקבל מ-Shopify את קידומת השפה, ולכן מי שגולש באנגלית נזרק חזרה לעברית בלחיצה.
   כאן כל קישור פנימי בלי קידומת מקבל את Shopify.routes.root ("/en/"). רק כשהשפה אינה ברירת המחדל.
   התגלה ב-ONEWHEEIL, 21.10.2026: קישורי המדיניות בפוטר החזירו לעברית. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root === '/' || window.__awLocaleLinks) return;
  window.__awLocaleLinks = true;
  var skip = /^\/(cdn|checkout|checkouts|services|apps|tools|account\/logout|\.well-known)(\/|$)/;
  function fix(scope) {
    (scope || document).querySelectorAll('a[href^="/"]:not([href^="//"])').forEach(function (a) {
      var href = a.getAttribute('href');
      if (href.indexOf(root) === 0 || href === root.slice(0, -1) || skip.test(href)) return;
      a.setAttribute('href', root + href.replace(/^\//, ''));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fix(); });
  else fix();
  document.addEventListener('shopify:section:load', function (e) { fix(e.target); });
  new MutationObserver(function (list) {
    list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) fix(n); }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
